(function () {


function $a3951d9daf6e8f2f$export$2e2bcd8739ae039() {
    const menuToggle = document.querySelector('[aria-controls="primary-menu"]');
    const mainNavigation = document.querySelector('.main-navigation');
    if (!menuToggle || !mainNavigation) return;
    menuToggle.addEventListener('click', ()=>{
        const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
        mainNavigation.classList.toggle('open', !isOpen);
        menuToggle.setAttribute('aria-expanded', String(!isOpen));
        document.body.classList.toggle('locked', !isOpen);
    });
}


function $4a50c2ddd107be52$export$2e2bcd8739ae039() {
    document.querySelectorAll(".popover-toggle").forEach((button)=>{
        positionSubMenuPopovers(button);
    });
    function positionSubMenuPopovers(button) {
        let left;
        if (button) left = button.getBoundingClientRect().x;
        let popOverTarget = button.getAttribute("popovertarget");
        // console.log("target:", popOverTarget);
        // set popover target position to lower left of button
        const popover = document.querySelector(`ul#${popOverTarget}`);
        console.log("Popover element:", popover);
        if (popover && left) popover.style.left = `${left}px`;
    }
    // resize observer to reposition popovers on window resize
    const resizeObserver = new ResizeObserver(()=>{
        document.querySelectorAll(".popover-toggle").forEach((button)=>{
            positionSubMenuPopovers(button);
        });
    });
    resizeObserver.observe(document.body);
}


function $138acfe71a391c39$export$2e2bcd8739ae039() {
    // https://inclusive-components.design/collapsible-sections/
    const accordions = document.querySelectorAll(".accordion");
    if (accordions) // Get all the <h2> headings
    accordions.forEach((accordion)=>{
        const _accordion = accordion;
        const headings = _accordion.querySelectorAll(".accordion__headline");
        // console.log('heading', headings);
        Array.prototype.forEach.call(headings, (heading)=>{
            const aria_controls_id = heading.getAttribute("data-id");
            // Give each <h2> a toggle button child
            // with the SVG plus/minus icon
            heading.innerHTML = `
						<button aria-expanded="false" aria-controls="${aria_controls_id}">
							<span>${heading.textContent}</span>
								<svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
									<!-- Horizontal line -->
									<line x1="20" y1="50" x2="80" y2="50" stroke="black" stroke-width="6"/>
									<!-- Vertical line -->
									<line x1="50" y1="20" x2="50" y2="80" stroke="black" stroke-width="6"/>
								</svg>
						</button>
					`;
            // Function to create a node list
            // of the content between this <h2> and the next
            const getContent = (elem)=>{
                const elems = [];
                let nextSibling = elem.nextElementSibling;
                while(nextSibling && nextSibling.tagName !== "H2" && nextSibling.tagName !== "H3"){
                    elems.push(nextSibling);
                    elem = nextSibling;
                    nextSibling = elem.nextElementSibling;
                }
                // Delete the old versions of the content nodes
                elems.forEach((node)=>{
                    if (node.parentNode) node.parentNode.removeChild(node);
                });
                return elems;
            };
            // Assign the contents to be expanded/collapsed (array)
            const contents = getContent(heading);
            // Create a wrapper element for `contents` and hide it
            const wrapper = document.createElement("div");
            wrapper.hidden = true;
            // Add each element of `contents` to `wrapper`
            contents.forEach((node)=>{
                wrapper.appendChild(node);
            });
            // Add the wrapped content back into the DOM
            // after the heading
            if (heading.parentNode) heading.parentNode.insertBefore(wrapper, heading.nextElementSibling);
            // Assign the button
            const btn = heading.querySelector("button");
            if (btn && aria_controls_id && window.location.hash === `#${aria_controls_id}`) expand(btn, wrapper, aria_controls_id);
            if (btn) btn.onclick = ()=>{
                expand(btn, wrapper, aria_controls_id || undefined);
            };
        });
    });
    function expand(btn, wrapper, aria_controls_id) {
        // Cast the state as a boolean
        const expanded = btn.getAttribute("aria-expanded") === "true";
        // Switch the state
        btn.setAttribute("aria-expanded", String(!expanded));
        // Switch the content's visibility
        wrapper.hidden = expanded;
    // if (!expanded && aria_controls_id) {
    //   window.location.hash = aria_controls_id;
    // } else {
    //   window.location.hash = "";
    // }
    }
}


function $f844812df082fc15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f844812df082fc15$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f844812df082fc15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f844812df082fc15$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $f844812df082fc15$var$CREATED = 1;
var $f844812df082fc15$var$MOUNTED = 2;
var $f844812df082fc15$var$IDLE = 3;
var $f844812df082fc15$var$MOVING = 4;
var $f844812df082fc15$var$SCROLLING = 5;
var $f844812df082fc15$var$DRAGGING = 6;
var $f844812df082fc15$var$DESTROYED = 7;
var $f844812df082fc15$var$STATES = {
    CREATED: $f844812df082fc15$var$CREATED,
    MOUNTED: $f844812df082fc15$var$MOUNTED,
    IDLE: $f844812df082fc15$var$IDLE,
    MOVING: $f844812df082fc15$var$MOVING,
    SCROLLING: $f844812df082fc15$var$SCROLLING,
    DRAGGING: $f844812df082fc15$var$DRAGGING,
    DESTROYED: $f844812df082fc15$var$DESTROYED
};
function $f844812df082fc15$var$empty(array) {
    array.length = 0;
}
function $f844812df082fc15$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $f844812df082fc15$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($f844812df082fc15$var$slice(arguments, 1)));
}
var $f844812df082fc15$var$nextTick = setTimeout;
var $f844812df082fc15$var$noop = function noop() {};
function $f844812df082fc15$var$raf(func) {
    return requestAnimationFrame(func);
}
function $f844812df082fc15$var$typeOf(type, subject) {
    return typeof subject === type;
}
function $f844812df082fc15$var$isObject(subject) {
    return !$f844812df082fc15$var$isNull(subject) && $f844812df082fc15$var$typeOf("object", subject);
}
var $f844812df082fc15$var$isArray = Array.isArray;
var $f844812df082fc15$var$isFunction = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "function");
var $f844812df082fc15$var$isString = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "string");
var $f844812df082fc15$var$isUndefined = $f844812df082fc15$var$apply($f844812df082fc15$var$typeOf, "undefined");
function $f844812df082fc15$var$isNull(subject) {
    return subject === null;
}
function $f844812df082fc15$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $f844812df082fc15$var$toArray(value) {
    return $f844812df082fc15$var$isArray(value) ? value : [
        value
    ];
}
function $f844812df082fc15$var$forEach(values, iteratee) {
    $f844812df082fc15$var$toArray(values).forEach(iteratee);
}
function $f844812df082fc15$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $f844812df082fc15$var$push(array, items) {
    array.push.apply(array, $f844812df082fc15$var$toArray(items));
    return array;
}
function $f844812df082fc15$var$toggleClass(elm, classes, add) {
    if (elm) $f844812df082fc15$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $f844812df082fc15$var$addClass(elm, classes) {
    $f844812df082fc15$var$toggleClass(elm, $f844812df082fc15$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $f844812df082fc15$var$append(parent, children) {
    $f844812df082fc15$var$forEach(children, parent.appendChild.bind(parent));
}
function $f844812df082fc15$var$before(nodes, ref) {
    $f844812df082fc15$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $f844812df082fc15$var$matches(elm, selector) {
    return $f844812df082fc15$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $f844812df082fc15$var$children(parent, selector) {
    var children2 = parent ? $f844812df082fc15$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $f844812df082fc15$var$matches(child, selector);
    }) : children2;
}
function $f844812df082fc15$var$child(parent, selector) {
    return selector ? $f844812df082fc15$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $f844812df082fc15$var$ownKeys = Object.keys;
function $f844812df082fc15$var$forOwn(object, iteratee, right) {
    if (object) (right ? $f844812df082fc15$var$ownKeys(object).reverse() : $f844812df082fc15$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $f844812df082fc15$var$assign(object) {
    $f844812df082fc15$var$slice(arguments, 1).forEach(function(source) {
        $f844812df082fc15$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $f844812df082fc15$var$merge(object) {
    $f844812df082fc15$var$slice(arguments, 1).forEach(function(source) {
        $f844812df082fc15$var$forOwn(source, function(value, key) {
            if ($f844812df082fc15$var$isArray(value)) object[key] = value.slice();
            else if ($f844812df082fc15$var$isObject(value)) object[key] = $f844812df082fc15$var$merge({}, $f844812df082fc15$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $f844812df082fc15$var$omit(object, keys) {
    $f844812df082fc15$var$forEach(keys || $f844812df082fc15$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $f844812df082fc15$var$removeAttribute(elms, attrs) {
    $f844812df082fc15$var$forEach(elms, function(elm) {
        $f844812df082fc15$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $f844812df082fc15$var$setAttribute(elms, attrs, value) {
    if ($f844812df082fc15$var$isObject(attrs)) $f844812df082fc15$var$forOwn(attrs, function(value2, name) {
        $f844812df082fc15$var$setAttribute(elms, name, value2);
    });
    else $f844812df082fc15$var$forEach(elms, function(elm) {
        $f844812df082fc15$var$isNull(value) || value === "" ? $f844812df082fc15$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $f844812df082fc15$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $f844812df082fc15$var$isString(attrs) ? $f844812df082fc15$var$addClass(elm, attrs) : $f844812df082fc15$var$setAttribute(elm, attrs);
    parent && $f844812df082fc15$var$append(parent, elm);
    return elm;
}
function $f844812df082fc15$var$style(elm, prop, value) {
    if ($f844812df082fc15$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$f844812df082fc15$var$isNull(value)) elm.style[prop] = "" + value;
}
function $f844812df082fc15$var$display(elm, display2) {
    $f844812df082fc15$var$style(elm, "display", display2);
}
function $f844812df082fc15$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $f844812df082fc15$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $f844812df082fc15$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $f844812df082fc15$var$rect(target) {
    return target.getBoundingClientRect();
}
function $f844812df082fc15$var$remove(nodes) {
    $f844812df082fc15$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $f844812df082fc15$var$parseHtml(html) {
    return $f844812df082fc15$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $f844812df082fc15$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $f844812df082fc15$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $f844812df082fc15$var$queryAll(parent, selector) {
    return selector ? $f844812df082fc15$var$slice(parent.querySelectorAll(selector)) : [];
}
function $f844812df082fc15$var$removeClass(elm, classes) {
    $f844812df082fc15$var$toggleClass(elm, classes, false);
}
function $f844812df082fc15$var$timeOf(e) {
    return e.timeStamp;
}
function $f844812df082fc15$var$unit(value) {
    return $f844812df082fc15$var$isString(value) ? value : value ? value + "px" : "";
}
var $f844812df082fc15$var$PROJECT_CODE = "splide";
var $f844812df082fc15$var$DATA_ATTRIBUTE = "data-" + $f844812df082fc15$var$PROJECT_CODE;
function $f844812df082fc15$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $f844812df082fc15$var$PROJECT_CODE + "] " + (message || ""));
}
var $f844812df082fc15$var$min = Math.min, $f844812df082fc15$var$max = Math.max, $f844812df082fc15$var$floor = Math.floor, $f844812df082fc15$var$ceil = Math.ceil, $f844812df082fc15$var$abs = Math.abs;
function $f844812df082fc15$var$approximatelyEqual(x, y, epsilon) {
    return $f844812df082fc15$var$abs(x - y) < epsilon;
}
function $f844812df082fc15$var$between(number, x, y, exclusive) {
    var minimum = $f844812df082fc15$var$min(x, y);
    var maximum = $f844812df082fc15$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $f844812df082fc15$var$clamp(number, x, y) {
    var minimum = $f844812df082fc15$var$min(x, y);
    var maximum = $f844812df082fc15$var$max(x, y);
    return $f844812df082fc15$var$min($f844812df082fc15$var$max(minimum, number), maximum);
}
function $f844812df082fc15$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $f844812df082fc15$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $f844812df082fc15$var$format(string, replacements) {
    $f844812df082fc15$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $f844812df082fc15$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $f844812df082fc15$var$ids = {};
function $f844812df082fc15$var$uniqueId(prefix) {
    return "" + prefix + $f844812df082fc15$var$pad($f844812df082fc15$var$ids[prefix] = ($f844812df082fc15$var$ids[prefix] || 0) + 1);
}
function $f844812df082fc15$export$c473e36ef1bda729() {
    var listeners = [];
    function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    }
    function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    }
    function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    }
    function forEachEvent(targets, events, iteratee) {
        $f844812df082fc15$var$forEach(targets, function(target) {
            target && $f844812df082fc15$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    }
    function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $f844812df082fc15$var$empty(listeners);
    }
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $f844812df082fc15$export$d300dc1a2634364b = "mounted";
var $f844812df082fc15$export$d8dac49b4532735a = "ready";
var $f844812df082fc15$export$2aa493d7c3275167 = "move";
var $f844812df082fc15$export$fe5802204b967f0d = "moved";
var $f844812df082fc15$export$5adb665701eda1ce = "click";
var $f844812df082fc15$export$92e3eae133acac4c = "active";
var $f844812df082fc15$export$6bcbb81035c12cea = "inactive";
var $f844812df082fc15$export$6a5b3445e4066a53 = "visible";
var $f844812df082fc15$export$8c5c7a21d54563e9 = "hidden";
var $f844812df082fc15$export$7f4701ac5e05e39f = "refresh";
var $f844812df082fc15$export$db40ab7c0855fa5c = "updated";
var $f844812df082fc15$export$7e019dae5103a285 = "resize";
var $f844812df082fc15$export$d637eba1e9e28482 = "resized";
var $f844812df082fc15$export$e84bf5065c9087ac = "drag";
var $f844812df082fc15$export$8e9f636d2c722196 = "dragging";
var $f844812df082fc15$export$90ea576bd3fdeb60 = "dragged";
var $f844812df082fc15$export$49801896908b5e33 = "scroll";
var $f844812df082fc15$export$ff8164bff3202b9 = "scrolled";
var $f844812df082fc15$export$6cbac5b662a31e1b = "overflow";
var $f844812df082fc15$export$88c4cf7419e470cd = "destroy";
var $f844812df082fc15$export$8647f6b043e04e9d = "arrows:mounted";
var $f844812df082fc15$export$d467f9343b961f75 = "arrows:updated";
var $f844812df082fc15$export$bf89a4e4349c9778 = "pagination:mounted";
var $f844812df082fc15$export$eb2019082ed6de0b = "pagination:updated";
var $f844812df082fc15$export$84015c33508f94ec = "navigation:mounted";
var $f844812df082fc15$export$23663268a31b79e2 = "autoplay:play";
var $f844812df082fc15$export$185723258309b608 = "autoplay:playing";
var $f844812df082fc15$export$16a1e4f3d0368265 = "autoplay:pause";
var $f844812df082fc15$export$9f64346e17f0ec8e = "lazyload:loaded";
var $f844812df082fc15$export$6d5af59619d10e6a = "sk";
var $f844812df082fc15$export$f0af896383d5adff = "sh";
var $f844812df082fc15$export$28dea85f216954dc = "ei";
function $f844812df082fc15$export$f188226459c8a3ff(Splide2) {
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $f844812df082fc15$export$c473e36ef1bda729();
    function on(events, callback) {
        binder.bind(bus, $f844812df082fc15$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $f844812df082fc15$var$isArray(e.detail) ? e.detail : []);
        });
    }
    function emit(event) {
        binder.dispatch(bus, event, $f844812df082fc15$var$slice(arguments, 1));
    }
    if (Splide2) Splide2.event.on($f844812df082fc15$export$88c4cf7419e470cd, binder.destroy);
    return $f844812df082fc15$var$assign(binder, {
        bus: bus,
        on: on,
        off: $f844812df082fc15$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $f844812df082fc15$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $f844812df082fc15$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $f844812df082fc15$var$raf(update);
        }
    }
    function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $f844812df082fc15$var$raf(update);
    }
    function pause() {
        paused = true;
    }
    function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    }
    function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    }
    function set(time) {
        interval = time;
    }
    function isPaused() {
        return paused;
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $f844812df082fc15$export$7254cc27399e90bd(initialState) {
    var state = initialState;
    function set(value) {
        state = value;
    }
    function is(states) {
        return $f844812df082fc15$var$includes($f844812df082fc15$var$toArray(states), state);
    }
    return {
        set: set,
        is: is
    };
}
function $f844812df082fc15$export$efff0f5979573c99(func, duration) {
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $f844812df082fc15$var$Media(Splide2, Components2, options) {
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $f844812df082fc15$export$c473e36ef1bda729();
    var queries = [];
    function setup() {
        var isMin = options.mediaQuery === "min";
        $f844812df082fc15$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    }
    function destroy(completely) {
        if (completely) binder.destroy();
    }
    function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    }
    function update() {
        var destroyed = state.is($f844812df082fc15$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $f844812df082fc15$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $f844812df082fc15$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    }
    function reduce(enable) {
        if (matchMedia($f844812df082fc15$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $f844812df082fc15$var$merge(options, reducedMotion) : $f844812df082fc15$var$omit(options, $f844812df082fc15$var$ownKeys(reducedMotion));
    }
    function set(opts, base, notify) {
        $f844812df082fc15$var$merge(options, opts);
        base && $f844812df082fc15$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($f844812df082fc15$var$CREATED)) Splide2.emit($f844812df082fc15$export$db40ab7c0855fa5c, options);
    }
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $f844812df082fc15$var$ARROW = "Arrow";
var $f844812df082fc15$var$ARROW_LEFT = $f844812df082fc15$var$ARROW + "Left";
var $f844812df082fc15$var$ARROW_RIGHT = $f844812df082fc15$var$ARROW + "Right";
var $f844812df082fc15$var$ARROW_UP = $f844812df082fc15$var$ARROW + "Up";
var $f844812df082fc15$var$ARROW_DOWN = $f844812df082fc15$var$ARROW + "Down";
var $f844812df082fc15$export$373e92e0788ff06e = "ltr";
var $f844812df082fc15$export$850f7749a2909601 = "rtl";
var $f844812df082fc15$export$97170d9824b89709 = "ttb";
var $f844812df082fc15$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $f844812df082fc15$var$ARROW_UP,
        $f844812df082fc15$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $f844812df082fc15$var$ARROW_DOWN,
        $f844812df082fc15$var$ARROW_LEFT
    ]
};
function $f844812df082fc15$var$Direction(Splide2, Components2, options) {
    function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $f844812df082fc15$export$850f7749a2909601 && !axisOnly ? 1 : direction === $f844812df082fc15$export$97170d9824b89709 ? 0 : -1;
        return $f844812df082fc15$var$ORIENTATION_MAP[prop] && $f844812df082fc15$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $f844812df082fc15$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    }
    function orient(value) {
        return value * (options.direction === $f844812df082fc15$export$850f7749a2909601 ? 1 : -1);
    }
    return {
        resolve: resolve,
        orient: orient
    };
}
var $f844812df082fc15$var$ROLE = "role";
var $f844812df082fc15$var$TAB_INDEX = "tabindex";
var $f844812df082fc15$var$DISABLED = "disabled";
var $f844812df082fc15$var$ARIA_PREFIX = "aria-";
var $f844812df082fc15$var$ARIA_CONTROLS = $f844812df082fc15$var$ARIA_PREFIX + "controls";
var $f844812df082fc15$var$ARIA_CURRENT = $f844812df082fc15$var$ARIA_PREFIX + "current";
var $f844812df082fc15$var$ARIA_SELECTED = $f844812df082fc15$var$ARIA_PREFIX + "selected";
var $f844812df082fc15$var$ARIA_LABEL = $f844812df082fc15$var$ARIA_PREFIX + "label";
var $f844812df082fc15$var$ARIA_LABELLEDBY = $f844812df082fc15$var$ARIA_PREFIX + "labelledby";
var $f844812df082fc15$var$ARIA_HIDDEN = $f844812df082fc15$var$ARIA_PREFIX + "hidden";
var $f844812df082fc15$var$ARIA_ORIENTATION = $f844812df082fc15$var$ARIA_PREFIX + "orientation";
var $f844812df082fc15$var$ARIA_ROLEDESCRIPTION = $f844812df082fc15$var$ARIA_PREFIX + "roledescription";
var $f844812df082fc15$var$ARIA_LIVE = $f844812df082fc15$var$ARIA_PREFIX + "live";
var $f844812df082fc15$var$ARIA_BUSY = $f844812df082fc15$var$ARIA_PREFIX + "busy";
var $f844812df082fc15$var$ARIA_ATOMIC = $f844812df082fc15$var$ARIA_PREFIX + "atomic";
var $f844812df082fc15$var$ALL_ATTRIBUTES = [
    $f844812df082fc15$var$ROLE,
    $f844812df082fc15$var$TAB_INDEX,
    $f844812df082fc15$var$DISABLED,
    $f844812df082fc15$var$ARIA_CONTROLS,
    $f844812df082fc15$var$ARIA_CURRENT,
    $f844812df082fc15$var$ARIA_LABEL,
    $f844812df082fc15$var$ARIA_LABELLEDBY,
    $f844812df082fc15$var$ARIA_HIDDEN,
    $f844812df082fc15$var$ARIA_ORIENTATION,
    $f844812df082fc15$var$ARIA_ROLEDESCRIPTION
];
var $f844812df082fc15$var$CLASS_PREFIX = $f844812df082fc15$var$PROJECT_CODE + "__";
var $f844812df082fc15$var$STATUS_CLASS_PREFIX = "is-";
var $f844812df082fc15$export$93b21159ad85c843 = $f844812df082fc15$var$PROJECT_CODE;
var $f844812df082fc15$export$7738b09ac0a98952 = $f844812df082fc15$var$CLASS_PREFIX + "track";
var $f844812df082fc15$export$19cc2a5451235cae = $f844812df082fc15$var$CLASS_PREFIX + "list";
var $f844812df082fc15$export$8d922915837a38d3 = $f844812df082fc15$var$CLASS_PREFIX + "slide";
var $f844812df082fc15$export$2c1ba4a4f1aa4947 = $f844812df082fc15$export$8d922915837a38d3 + "--clone";
var $f844812df082fc15$export$e9ba7e444ba60a12 = $f844812df082fc15$export$8d922915837a38d3 + "__container";
var $f844812df082fc15$export$a26cbd955fecf11e = $f844812df082fc15$var$CLASS_PREFIX + "arrows";
var $f844812df082fc15$export$516e7d18e13a2dca = $f844812df082fc15$var$CLASS_PREFIX + "arrow";
var $f844812df082fc15$export$58ea3db24c33b76 = $f844812df082fc15$export$516e7d18e13a2dca + "--prev";
var $f844812df082fc15$export$4885afd7098a65c2 = $f844812df082fc15$export$516e7d18e13a2dca + "--next";
var $f844812df082fc15$export$cbf8e5a0ab95eda3 = $f844812df082fc15$var$CLASS_PREFIX + "pagination";
var $f844812df082fc15$export$52f2cca6a5eee805 = $f844812df082fc15$export$cbf8e5a0ab95eda3 + "__page";
var $f844812df082fc15$export$4c82dc32b1c4ace5 = $f844812df082fc15$var$CLASS_PREFIX + "progress";
var $f844812df082fc15$export$2c9b091c749f4409 = $f844812df082fc15$export$4c82dc32b1c4ace5 + "__bar";
var $f844812df082fc15$export$a29701deef84b825 = $f844812df082fc15$var$CLASS_PREFIX + "toggle";
var $f844812df082fc15$export$d9d247d51b430dbb = $f844812df082fc15$export$a29701deef84b825 + "__play";
var $f844812df082fc15$export$3529f201a419925b = $f844812df082fc15$export$a29701deef84b825 + "__pause";
var $f844812df082fc15$export$3e5381ee3fab8374 = $f844812df082fc15$var$CLASS_PREFIX + "spinner";
var $f844812df082fc15$export$bb78d7c200da8960 = $f844812df082fc15$var$CLASS_PREFIX + "sr";
var $f844812df082fc15$export$7761661e2d5b9388 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "initialized";
var $f844812df082fc15$export$72d36ecf3758cb4b = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "active";
var $f844812df082fc15$export$e423ac4972f5e196 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "prev";
var $f844812df082fc15$export$457a2d20827a2779 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "next";
var $f844812df082fc15$export$53ca4621bbab9a = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "visible";
var $f844812df082fc15$export$d22ec4ccb7996ba2 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "loading";
var $f844812df082fc15$export$b6f202a162a09100 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "focus-in";
var $f844812df082fc15$export$cd908cd1dd625e29 = $f844812df082fc15$var$STATUS_CLASS_PREFIX + "overflow";
var $f844812df082fc15$export$49f9eaea10ebf193 = [
    $f844812df082fc15$export$72d36ecf3758cb4b,
    $f844812df082fc15$export$53ca4621bbab9a,
    $f844812df082fc15$export$e423ac4972f5e196,
    $f844812df082fc15$export$457a2d20827a2779,
    $f844812df082fc15$export$d22ec4ccb7996ba2,
    $f844812df082fc15$export$b6f202a162a09100,
    $f844812df082fc15$export$cd908cd1dd625e29
];
var $f844812df082fc15$export$ba41d43e4a419565 = {
    slide: $f844812df082fc15$export$8d922915837a38d3,
    clone: $f844812df082fc15$export$2c1ba4a4f1aa4947,
    arrows: $f844812df082fc15$export$a26cbd955fecf11e,
    arrow: $f844812df082fc15$export$516e7d18e13a2dca,
    prev: $f844812df082fc15$export$58ea3db24c33b76,
    next: $f844812df082fc15$export$4885afd7098a65c2,
    pagination: $f844812df082fc15$export$cbf8e5a0ab95eda3,
    page: $f844812df082fc15$export$52f2cca6a5eee805,
    spinner: $f844812df082fc15$export$3e5381ee3fab8374
};
function $f844812df082fc15$var$closest(from, selector) {
    if ($f844812df082fc15$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($f844812df082fc15$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $f844812df082fc15$var$FRICTION = 5;
var $f844812df082fc15$var$LOG_INTERVAL = 200;
var $f844812df082fc15$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $f844812df082fc15$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $f844812df082fc15$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $f844812df082fc15$var$Elements(Splide2, Components2, options) {
    var _EventInterface = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    function setup() {
        collect();
        init();
        update();
    }
    function mount() {
        on($f844812df082fc15$export$7f4701ac5e05e39f, destroy);
        on($f844812df082fc15$export$7f4701ac5e05e39f, setup);
        on($f844812df082fc15$export$db40ab7c0855fa5c, update);
        bind(document, $f844812df082fc15$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $f844812df082fc15$var$toggleClass(root, $f844812df082fc15$export$b6f202a162a09100, !!isUsingKey);
        });
    }
    function destroy(completely) {
        var attrs = $f844812df082fc15$var$ALL_ATTRIBUTES.concat("style");
        $f844812df082fc15$var$empty(slides);
        $f844812df082fc15$var$removeClass(root, rootClasses);
        $f844812df082fc15$var$removeClass(track, trackClasses);
        $f844812df082fc15$var$removeAttribute([
            track,
            list
        ], attrs);
        $f844812df082fc15$var$removeAttribute(root, completely ? attrs : [
            "style",
            $f844812df082fc15$var$ARIA_ROLEDESCRIPTION
        ]);
    }
    function update() {
        $f844812df082fc15$var$removeClass(root, rootClasses);
        $f844812df082fc15$var$removeClass(track, trackClasses);
        rootClasses = getClasses($f844812df082fc15$export$93b21159ad85c843);
        trackClasses = getClasses($f844812df082fc15$export$7738b09ac0a98952);
        $f844812df082fc15$var$addClass(root, rootClasses);
        $f844812df082fc15$var$addClass(track, trackClasses);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_LABEL, options.label);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_LABELLEDBY, options.labelledby);
    }
    function collect() {
        track = find("." + $f844812df082fc15$export$7738b09ac0a98952);
        list = $f844812df082fc15$var$child(track, "." + $f844812df082fc15$export$19cc2a5451235cae);
        $f844812df082fc15$var$assert(track && list, "A track/list element is missing.");
        $f844812df082fc15$var$push(slides, $f844812df082fc15$var$children(list, "." + $f844812df082fc15$export$8d922915837a38d3 + ":not(." + $f844812df082fc15$export$2c1ba4a4f1aa4947 + ")"));
        $f844812df082fc15$var$forOwn({
            arrows: $f844812df082fc15$export$a26cbd955fecf11e,
            pagination: $f844812df082fc15$export$cbf8e5a0ab95eda3,
            prev: $f844812df082fc15$export$58ea3db24c33b76,
            next: $f844812df082fc15$export$4885afd7098a65c2,
            bar: $f844812df082fc15$export$2c9b091c749f4409,
            toggle: $f844812df082fc15$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $f844812df082fc15$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    }
    function init() {
        var id = root.id || $f844812df082fc15$var$uniqueId($f844812df082fc15$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ROLE) && root.tagName !== "SECTION" && role) $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ROLE, role);
        $f844812df082fc15$var$setAttribute(root, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ROLE, "presentation");
    }
    function find(selector) {
        var elm = $f844812df082fc15$var$query(root, selector);
        return elm && $f844812df082fc15$var$closest(elm, "." + $f844812df082fc15$export$93b21159ad85c843) === root ? elm : void 0;
    }
    function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $f844812df082fc15$export$93b21159ad85c843 && $f844812df082fc15$export$72d36ecf3758cb4b
        ];
    }
    return $f844812df082fc15$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $f844812df082fc15$export$e5a58a5ee5b54c22 = "slide";
var $f844812df082fc15$export$f42383286ed1223d = "loop";
var $f844812df082fc15$export$742b62a5690c060 = "fade";
function $f844812df082fc15$var$Slide$1(Splide2, index, slideIndex, slide) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $f844812df082fc15$var$getAttribute(slide, "style");
    var label = $f844812df082fc15$var$getAttribute(slide, $f844812df082fc15$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $f844812df082fc15$var$child(slide, "." + $f844812df082fc15$export$e9ba7e444ba60a12);
    var destroyed;
    function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $f844812df082fc15$var$pad(index + 1);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ROLE, pagination ? "tabpanel" : "group");
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, label || $f844812df082fc15$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    }
    function listen() {
        bind(slide, "click", $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$6d5af59619d10e6a, self));
        on([
            $f844812df082fc15$export$fe5802204b967f0d,
            $f844812df082fc15$export$f0af896383d5adff,
            $f844812df082fc15$export$ff8164bff3202b9
        ], update);
        on($f844812df082fc15$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function destroy() {
        destroyed = true;
        event.destroy();
        $f844812df082fc15$var$removeClass(slide, $f844812df082fc15$export$49f9eaea10ebf193);
        $f844812df082fc15$var$removeAttribute(slide, $f844812df082fc15$var$ALL_ATTRIBUTES);
        $f844812df082fc15$var$setAttribute(slide, "style", styles);
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, label || "");
    }
    function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_LABEL, $f844812df082fc15$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_CONTROLS, controls);
        $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $f844812df082fc15$var$removeAttribute(slide, $f844812df082fc15$var$ARIA_ROLEDESCRIPTION);
    }
    function onMove() {
        if (!destroyed) update();
    }
    function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$e423ac4972f5e196, index === curr - 1);
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$457a2d20827a2779, index === curr + 1);
        }
    }
    function updateActivity() {
        var active = isActive();
        if (active !== $f844812df082fc15$var$hasClass(slide, $f844812df082fc15$export$72d36ecf3758cb4b)) {
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$72d36ecf3758cb4b, active);
            $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $f844812df082fc15$export$92e3eae133acac4c : $f844812df082fc15$export$6bcbb81035c12cea, self);
        }
    }
    function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $f844812df082fc15$var$MOVING,
            $f844812df082fc15$var$SCROLLING
        ])) $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$ARIA_HIDDEN, hidden || "");
        $f844812df082fc15$var$setAttribute($f844812df082fc15$var$queryAll(slide, options.focusableNodes || ""), $f844812df082fc15$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $f844812df082fc15$var$setAttribute(slide, $f844812df082fc15$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $f844812df082fc15$var$hasClass(slide, $f844812df082fc15$export$53ca4621bbab9a)) {
            $f844812df082fc15$var$toggleClass(slide, $f844812df082fc15$export$53ca4621bbab9a, visible);
            emit(visible ? $f844812df082fc15$export$6a5b3445e4066a53 : $f844812df082fc15$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $f844812df082fc15$var$focus(Slide2.slide);
        }
    }
    function style$1(prop, value, useContainer) {
        $f844812df082fc15$var$style(useContainer && container || slide, prop, value);
    }
    function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    }
    function isVisible() {
        if (Splide2.is($f844812df082fc15$export$742b62a5690c060)) return isActive();
        var trackRect = $f844812df082fc15$var$rect(Components.Elements.track);
        var slideRect = $f844812df082fc15$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $f844812df082fc15$var$floor(trackRect[left]) <= $f844812df082fc15$var$ceil(slideRect[left]) && $f844812df082fc15$var$floor(slideRect[right]) <= $f844812df082fc15$var$ceil(trackRect[right]);
    }
    function isWithin(from, distance) {
        var diff = $f844812df082fc15$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($f844812df082fc15$export$f42383286ed1223d))) diff = $f844812df082fc15$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    }
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $f844812df082fc15$var$Slides(Splide2, Components2, options) {
    var _EventInterface2 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    function mount() {
        init();
        on($f844812df082fc15$export$7f4701ac5e05e39f, destroy);
        on($f844812df082fc15$export$7f4701ac5e05e39f, init);
    }
    function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    }
    function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $f844812df082fc15$var$empty(Slides2);
    }
    function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    }
    function register(slide, index, slideIndex) {
        var object = $f844812df082fc15$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    }
    function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    }
    function getIn(page) {
        var Controller = Components2.Controller;
        var index = Controller.toIndex(page);
        var max = Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $f844812df082fc15$var$between(Slide2.index, index, index + max - 1);
        });
    }
    function getAt(index) {
        return filter(index)[0];
    }
    function add(items, index) {
        $f844812df082fc15$var$forEach(items, function(slide) {
            if ($f844812df082fc15$var$isString(slide)) slide = $f844812df082fc15$var$parseHtml(slide);
            if ($f844812df082fc15$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $f844812df082fc15$var$before(slide, ref) : $f844812df082fc15$var$append(list, slide);
                $f844812df082fc15$var$addClass(slide, options.classes.slide);
                observeImages(slide, $f844812df082fc15$var$apply(emit, $f844812df082fc15$export$7e019dae5103a285));
            }
        });
        emit($f844812df082fc15$export$7f4701ac5e05e39f);
    }
    function remove$1(matcher) {
        $f844812df082fc15$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($f844812df082fc15$export$7f4701ac5e05e39f);
    }
    function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    }
    function filter(matcher) {
        return Slides2.filter($f844812df082fc15$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $f844812df082fc15$var$isString(matcher) ? $f844812df082fc15$var$matches(Slide2.slide, matcher) : $f844812df082fc15$var$includes($f844812df082fc15$var$toArray(matcher), Slide2.index);
        });
    }
    function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    }
    function observeImages(elm, callback) {
        var images = $f844812df082fc15$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    }
    function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    }
    function isEnough() {
        return Slides2.length > options.perPage;
    }
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $f844812df082fc15$var$Layout(Splide2, Components2, options) {
    var _EventInterface3 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = Slides.getAt, styleSlides = Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    function mount() {
        init();
        bind(window, "resize load", $f844812df082fc15$export$efff0f5979573c99($f844812df082fc15$var$apply(emit, $f844812df082fc15$export$7e019dae5103a285)));
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], init);
        on($f844812df082fc15$export$7e019dae5103a285, resize);
    }
    function init() {
        vertical = options.direction === $f844812df082fc15$export$97170d9824b89709;
        $f844812df082fc15$var$style(root, "maxWidth", $f844812df082fc15$var$unit(options.width));
        $f844812df082fc15$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $f844812df082fc15$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    }
    function resize(force) {
        var newRect = $f844812df082fc15$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $f844812df082fc15$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $f844812df082fc15$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($f844812df082fc15$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $f844812df082fc15$var$toggleClass(root, $f844812df082fc15$export$cd908cd1dd625e29, overflow);
                emit($f844812df082fc15$export$6cbac5b662a31e1b, overflow);
            }
        }
    }
    function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $f844812df082fc15$var$unit(padding[prop] || ($f844812df082fc15$var$isObject(padding) ? 0 : padding)) || "0px";
    }
    function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $f844812df082fc15$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    }
    function cssHeight() {
        return $f844812df082fc15$var$unit(options.height || $f844812df082fc15$var$rect(list).width * options.heightRatio);
    }
    function cssSlideWidth() {
        return options.autoWidth ? null : $f844812df082fc15$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    }
    function cssSlideHeight() {
        return $f844812df082fc15$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    }
    function cssSlideSize() {
        var gap = $f844812df082fc15$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    }
    function listSize() {
        return $f844812df082fc15$var$rect(list)[resolve("width")];
    }
    function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $f844812df082fc15$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    }
    function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $f844812df082fc15$var$rect(Slide.slide)[resolve("right")];
            var left = $f844812df082fc15$var$rect(list)[resolve("left")];
            return $f844812df082fc15$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    }
    function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    }
    function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($f844812df082fc15$var$style(Slide.slide, resolve("marginRight"))) || 0;
    }
    function getPadding(right) {
        return parseFloat($f844812df082fc15$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    }
    function isOverflow() {
        return Splide2.is($f844812df082fc15$export$742b62a5690c060) || sliderSize(true) > listSize();
    }
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $f844812df082fc15$var$MULTIPLIER = 2;
function $f844812df082fc15$var$Clones(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var Elements = Components2.Elements, Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    function mount() {
        on($f844812df082fc15$export$7f4701ac5e05e39f, remount);
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    }
    function remount() {
        destroy();
        mount();
    }
    function destroy() {
        $f844812df082fc15$var$remove(clones);
        $f844812df082fc15$var$empty(clones);
        event.destroy();
    }
    function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($f844812df082fc15$export$7f4701ac5e05e39f);
        }
    }
    function generate(count) {
        var slides = Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$f844812df082fc15$var$push(slides, slides);
            $f844812df082fc15$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $f844812df082fc15$var$before(clone, slides[0].slide) : $f844812df082fc15$var$append(Elements.list, clone);
                $f844812df082fc15$var$push(clones, clone);
                Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    }
    function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $f844812df082fc15$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $f844812df082fc15$var$pad(index + 1);
        return clone;
    }
    function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($f844812df082fc15$export$f42383286ed1223d)) clones2 = 0;
        else if ($f844812df082fc15$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $f844812df082fc15$var$ceil($f844812df082fc15$var$rect(Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $f844812df082fc15$var$MULTIPLIER;
        }
        return clones2;
    }
    return {
        mount: mount,
        destroy: destroy
    };
}
function $f844812df082fc15$var$Move(Splide2, Components2, options) {
    var _EventInterface4 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    function mount() {
        Transition = Components2.Transition;
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$d637eba1e9e28482,
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], reposition);
    }
    function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    }
    function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($f844812df082fc15$var$MOVING);
        emit($f844812df082fc15$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($f844812df082fc15$var$IDLE);
            emit($f844812df082fc15$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    }
    function jump(index) {
        translate(toPosition(index, true));
    }
    function translate(position, preventLoop) {
        if (!Splide2.is($f844812df082fc15$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $f844812df082fc15$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($f844812df082fc15$export$f0af896383d5adff);
        }
    }
    function loop(position) {
        if (Splide2.is($f844812df082fc15$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    }
    function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($f844812df082fc15$var$ceil($f844812df082fc15$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    }
    function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    }
    function toIndex(position) {
        var Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < Slides.length; i++){
            var slideIndex = Slides[i].index;
            var distance = $f844812df082fc15$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    }
    function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    }
    function getPosition() {
        var left = resolve("left");
        return $f844812df082fc15$var$rect(list)[left] - $f844812df082fc15$var$rect(track)[left] + orient(getPadding(false));
    }
    function trim(position) {
        if (options.trimSpace && Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22)) position = $f844812df082fc15$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    }
    function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    }
    function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    }
    function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $f844812df082fc15$var$rect(track)[resolve("width")];
    }
    function exceededLimit(max, position) {
        position = $f844812df082fc15$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    }
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $f844812df082fc15$var$Controller(Splide2, Components2, options) {
    var _EventInterface5 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, toPosition = Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($f844812df082fc15$export$f42383286ed1223d);
    var isSlide = Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22);
    var getNext = $f844812df082fc15$var$apply(getAdjacent, false);
    var getPrev = $f844812df082fc15$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    function mount() {
        init();
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$28dea85f216954dc
        ], init);
        on($f844812df082fc15$export$d637eba1e9e28482, onResized);
    }
    function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $f844812df082fc15$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            Move.reposition();
        }
    }
    function onResized() {
        if (endIndex !== getEnd()) emit($f844812df082fc15$export$28dea85f216954dc);
    }
    function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                Move.move(dest, index, prevIndex, callback);
            }
        }
    }
    function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(Move.toIndex(getPosition()));
            setIndex(omitEnd ? $f844812df082fc15$var$min(index, endIndex) : index);
            callback && callback();
        });
    }
    function parse(control) {
        var index = currIndex;
        if ($f844812df082fc15$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $f844812df082fc15$var$clamp(control, 0, endIndex);
        return index;
    }
    function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$f844812df082fc15$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    }
    function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($f844812df082fc15$var$between(0, dest, from, true) || $f844812df082fc15$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    }
    function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $f844812df082fc15$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    }
    function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    }
    function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $f844812df082fc15$var$clamp(end, 0, slideCount - 1);
    }
    function toIndex(page) {
        return $f844812df082fc15$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    }
    function toPage(index) {
        return hasFocus() ? $f844812df082fc15$var$min(index, endIndex) : $f844812df082fc15$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    }
    function toDest(destination) {
        var closest = Move.toIndex(destination);
        return isSlide ? $f844812df082fc15$var$clamp(closest, 0, endIndex) : closest;
    }
    function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    }
    function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    }
    function hasFocus() {
        return !$f844812df082fc15$var$isUndefined(options.focus) || options.isNavigation;
    }
    function isBusy() {
        return Splide2.state.is([
            $f844812df082fc15$var$MOVING,
            $f844812df082fc15$var$SCROLLING
        ]) && !!options.waitForTransition;
    }
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $f844812df082fc15$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $f844812df082fc15$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $f844812df082fc15$var$SIZE = 40;
function $f844812df082fc15$var$Arrows(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var Elements = Components2.Elements, Controller = Components2.Controller;
    var placeholder = Elements.arrows, track = Elements.track;
    var wrapper = placeholder;
    var prev = Elements.prev;
    var next = Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    function mount() {
        init();
        on($f844812df082fc15$export$db40ab7c0855fa5c, remount);
    }
    function remount() {
        destroy();
        mount();
    }
    function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $f844812df082fc15$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $f844812df082fc15$var$display(wrapper, enabled ? "" : "none");
            $f844812df082fc15$var$addClass(wrapper, wrapperClasses = $f844812df082fc15$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $f844812df082fc15$var$setAttribute([
                    prev,
                    next
                ], $f844812df082fc15$var$ARIA_CONTROLS, track.id);
                emit($f844812df082fc15$export$8647f6b043e04e9d, prev, next);
            }
        }
    }
    function destroy() {
        event.destroy();
        $f844812df082fc15$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $f844812df082fc15$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $f844812df082fc15$var$removeAttribute([
            prev,
            next
        ], $f844812df082fc15$var$ALL_ATTRIBUTES);
    }
    function listen() {
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$fe5802204b967f0d,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$ff8164bff3202b9,
            $f844812df082fc15$export$28dea85f216954dc
        ], update);
        bind(next, "click", $f844812df082fc15$var$apply(go, ">"));
        bind(prev, "click", $f844812df082fc15$var$apply(go, "<"));
    }
    function go(control) {
        Controller.go(control, true);
    }
    function createArrows() {
        wrapper = placeholder || $f844812df082fc15$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $f844812df082fc15$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $f844812df082fc15$var$before(wrapper, track);
    }
    function createArrow(prev2) {
        var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + $f844812df082fc15$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $f844812df082fc15$var$SIZE + " " + $f844812df082fc15$var$SIZE + "\" width=\"" + $f844812df082fc15$var$SIZE + "\" height=\"" + $f844812df082fc15$var$SIZE + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || $f844812df082fc15$var$PATH) + "\" />";
        return $f844812df082fc15$var$parseHtml(arrow);
    }
    function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = Controller.getPrev();
            var nextIndex = Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $f844812df082fc15$var$setAttribute(prev, $f844812df082fc15$var$ARIA_LABEL, prevLabel);
            $f844812df082fc15$var$setAttribute(next, $f844812df082fc15$var$ARIA_LABEL, nextLabel);
            emit($f844812df082fc15$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    }
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $f844812df082fc15$var$INTERVAL_DATA_ATTRIBUTE = $f844812df082fc15$var$DATA_ATTRIBUTE + "-interval";
function $f844812df082fc15$var$Autoplay(Splide2, Components2, options) {
    var _EventInterface6 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    function mount() {
        if (autoplay) {
            listen();
            toggle && $f844812df082fc15$var$setAttribute(toggle, $f844812df082fc15$var$ARIA_CONTROLS, Elements.track.id);
            stopped || play();
            update();
        }
    }
    function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $f844812df082fc15$export$2aa493d7c3275167,
            $f844812df082fc15$export$49801896908b5e33,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($f844812df082fc15$export$23663268a31b79e2);
        }
    }
    function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($f844812df082fc15$export$16a1e4f3d0368265);
        }
    }
    function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    }
    function update() {
        if (toggle) {
            $f844812df082fc15$var$toggleClass(toggle, $f844812df082fc15$export$72d36ecf3758cb4b, !stopped);
            $f844812df082fc15$var$setAttribute(toggle, $f844812df082fc15$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    }
    function onAnimationFrame(rate) {
        var bar = Elements.bar;
        bar && $f844812df082fc15$var$style(bar, "width", rate * 100 + "%");
        emit($f844812df082fc15$export$185723258309b608, rate);
    }
    function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$f844812df082fc15$var$getAttribute(Slide.slide, $f844812df082fc15$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    }
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $f844812df082fc15$var$Cover(Splide2, Components2, options) {
    var _EventInterface7 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    function mount() {
        if (options.cover) {
            on($f844812df082fc15$export$9f64346e17f0ec8e, $f844812df082fc15$var$apply(toggle, true));
            on([
                $f844812df082fc15$export$d300dc1a2634364b,
                $f844812df082fc15$export$db40ab7c0855fa5c,
                $f844812df082fc15$export$7f4701ac5e05e39f
            ], $f844812df082fc15$var$apply(cover, true));
        }
    }
    function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $f844812df082fc15$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    }
    function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);
        $f844812df082fc15$var$display(img, cover2 ? "none" : "");
    }
    return {
        mount: mount,
        destroy: $f844812df082fc15$var$apply(cover, false)
    };
}
var $f844812df082fc15$var$BOUNCE_DIFF_THRESHOLD = 10;
var $f844812df082fc15$var$BOUNCE_DURATION = 600;
var $f844812df082fc15$var$FRICTION_FACTOR = 0.6;
var $f844812df082fc15$var$BASE_VELOCITY = 1.5;
var $f844812df082fc15$var$MIN_DURATION = 800;
function $f844812df082fc15$var$Scroll(Splide2, Components2, options) {
    var _EventInterface8 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var Move = Components2.Move;
    var getPosition = Move.getPosition, getLimit = Move.getLimit, exceededLimit = Move.exceededLimit, translate = Move.translate;
    var isSlide = Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    function mount() {
        on($f844812df082fc15$export$2aa493d7c3275167, clear);
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], cancel);
    }
    function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $f844812df082fc15$var$sign(destination) * size * $f844812df082fc15$var$floor($f844812df082fc15$var$abs(destination) / size) || 0;
            destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $f844812df082fc15$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $f844812df082fc15$var$max($f844812df082fc15$var$abs(destination - from) / $f844812df082fc15$var$BASE_VELOCITY, $f844812df082fc15$var$MIN_DURATION);
        callback = onScrolled;
        interval = $f844812df082fc15$export$46ad21b25b6dccf0(duration, onEnd, $f844812df082fc15$var$apply(update, from, destination, noConstrain), 1);
        set($f844812df082fc15$var$SCROLLING);
        emit($f844812df082fc15$export$49801896908b5e33);
        interval.start();
    }
    function onEnd() {
        set($f844812df082fc15$var$IDLE);
        callback && callback();
        emit($f844812df082fc15$export$ff8164bff3202b9);
    }
    function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $f844812df082fc15$var$FRICTION_FACTOR;
            if ($f844812df082fc15$var$abs(diff) < $f844812df082fc15$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $f844812df082fc15$var$BOUNCE_DURATION, false, callback, true);
        }
    }
    function clear() {
        if (interval) interval.cancel();
    }
    function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    }
    function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    }
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $f844812df082fc15$var$Drag(Splide2, Components2, options) {
    var _EventInterface9 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var Move = Components2.Move, Scroll = Components2.Scroll, Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = Move.getPosition, exceededLimit = Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function mount() {
        bind(track, $f844812df082fc15$var$POINTER_MOVE_EVENTS, $f844812df082fc15$var$noop, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $f844812df082fc15$var$POINTER_UP_EVENTS, $f844812df082fc15$var$noop, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $f844812df082fc15$var$POINTER_DOWN_EVENTS, onPointerDown, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $f844812df082fc15$var$prevent);
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$db40ab7c0855fa5c
        ], init);
    }
    function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    }
    function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $f844812df082fc15$var$MOVING,
                        $f844812df082fc15$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $f844812df082fc15$var$POINTER_MOVE_EVENTS, onPointerMove, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $f844812df082fc15$var$POINTER_UP_EVENTS, onPointerUp, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
                    Move.cancel();
                    Scroll.cancel();
                    save(e);
                } else $f844812df082fc15$var$prevent(e, true);
            }
        }
    }
    function onPointerMove(e) {
        if (!state.is($f844812df082fc15$var$DRAGGING)) {
            state.set($f844812df082fc15$var$DRAGGING);
            emit($f844812df082fc15$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $f844812df082fc15$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($f844812df082fc15$export$8e9f636d2c722196);
                $f844812df082fc15$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $f844812df082fc15$var$prevent(e);
            }
        }
    }
    function onPointerUp(e) {
        if (state.is($f844812df082fc15$var$DRAGGING)) {
            state.set($f844812df082fc15$var$IDLE);
            emit($f844812df082fc15$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $f844812df082fc15$var$prevent(e);
        }
        unbind(target, $f844812df082fc15$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $f844812df082fc15$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    function onClick(e) {
        if (!disabled && clickPrevented) $f844812df082fc15$var$prevent(e, true);
    }
    function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    }
    function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($f844812df082fc15$export$742b62a5690c060)) Controller.go(orient($f844812df082fc15$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) && exceeded && rewind) Controller.go(exceededLimit(true) ? ">" : "<");
        else Controller.go(Controller.toDest(destination), true);
        reduce(true);
    }
    function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $f844812df082fc15$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $f844812df082fc15$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    }
    function isSliderDirection(e) {
        return $f844812df082fc15$var$abs(diffCoord(e)) > $f844812df082fc15$var$abs(diffCoord(e, true));
    }
    function computeVelocity(e) {
        if (Splide2.is($f844812df082fc15$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $f844812df082fc15$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    }
    function computeDestination(velocity) {
        return getPosition() + $f844812df082fc15$var$sign(velocity) * $f844812df082fc15$var$min($f844812df082fc15$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    }
    function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    }
    function diffTime(e) {
        return $f844812df082fc15$var$timeOf(e) - $f844812df082fc15$var$timeOf(getBaseEvent(e));
    }
    function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    }
    function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    }
    function constrain(diff) {
        return diff / (exceeded && Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) ? $f844812df082fc15$var$FRICTION : 1);
    }
    function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$f844812df082fc15$var$matches(target2, "." + $f844812df082fc15$export$52f2cca6a5eee805 + ", ." + $f844812df082fc15$export$516e7d18e13a2dca) && (!noDrag || !$f844812df082fc15$var$matches(target2, noDrag));
    }
    function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    }
    function isDragging() {
        return dragging;
    }
    function disable(value) {
        disabled = value;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $f844812df082fc15$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $f844812df082fc15$var$ARROW_RIGHT,
    Left: $f844812df082fc15$var$ARROW_LEFT,
    Up: $f844812df082fc15$var$ARROW_UP,
    Down: $f844812df082fc15$var$ARROW_DOWN
};
function $f844812df082fc15$var$normalizeKey(key) {
    key = $f844812df082fc15$var$isString(key) ? key : key.key;
    return $f844812df082fc15$var$NORMALIZATION_MAP[key] || key;
}
var $f844812df082fc15$var$KEYBOARD_EVENT = "keydown";
function $f844812df082fc15$var$Keyboard(Splide2, Components2, options) {
    var _EventInterface10 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    function mount() {
        init();
        on($f844812df082fc15$export$db40ab7c0855fa5c, destroy);
        on($f844812df082fc15$export$db40ab7c0855fa5c, init);
        on($f844812df082fc15$export$2aa493d7c3275167, onMove);
    }
    function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $f844812df082fc15$var$KEYBOARD_EVENT, onKeydown);
        }
    }
    function destroy() {
        unbind(target, $f844812df082fc15$var$KEYBOARD_EVENT);
    }
    function disable(value) {
        disabled = value;
    }
    function onMove() {
        var _disabled = disabled;
        disabled = true;
        $f844812df082fc15$var$nextTick(function() {
            disabled = _disabled;
        });
    }
    function onKeydown(e) {
        if (!disabled) {
            var key = $f844812df082fc15$var$normalizeKey(e);
            if (key === resolve($f844812df082fc15$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($f844812df082fc15$var$ARROW_RIGHT)) Splide2.go(">");
        }
    }
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $f844812df082fc15$var$SRC_DATA_ATTRIBUTE = $f844812df082fc15$var$DATA_ATTRIBUTE + "-lazy";
var $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE = $f844812df082fc15$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $f844812df082fc15$var$IMAGE_SELECTOR = "[" + $f844812df082fc15$var$SRC_DATA_ATTRIBUTE + "], [" + $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE + "]";
function $f844812df082fc15$var$LazyLoad(Splide2, Components2, options) {
    var _EventInterface11 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $f844812df082fc15$export$fe5802204b967f0d,
        $f844812df082fc15$export$ff8164bff3202b9
    ];
    var entries = [];
    function mount() {
        if (options.lazyLoad) {
            init();
            on($f844812df082fc15$export$7f4701ac5e05e39f, init);
        }
    }
    function init() {
        $f844812df082fc15$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    }
    function register() {
        Components2.Slides.forEach(function(Slide) {
            $f844812df082fc15$var$queryAll(Slide.slide, $f844812df082fc15$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE);
                var srcset = $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $f844812df082fc15$var$child(parent, "." + className) || $f844812df082fc15$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $f844812df082fc15$var$display(img, "none");
                }
            });
        });
    }
    function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    }
    function load(data) {
        var img = data[0];
        $f844812df082fc15$var$addClass(data[1].slide, $f844812df082fc15$export$d22ec4ccb7996ba2);
        bind(img, "load error", $f844812df082fc15$var$apply(onLoad, data));
        $f844812df082fc15$var$setAttribute(img, "src", $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE));
        $f844812df082fc15$var$setAttribute(img, "srcset", $f844812df082fc15$var$getAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE));
        $f844812df082fc15$var$removeAttribute(img, $f844812df082fc15$var$SRC_DATA_ATTRIBUTE);
        $f844812df082fc15$var$removeAttribute(img, $f844812df082fc15$var$SRCSET_DATA_ATTRIBUTE);
    }
    function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $f844812df082fc15$var$removeClass(Slide.slide, $f844812df082fc15$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $f844812df082fc15$var$remove(data[2]);
            $f844812df082fc15$var$display(img, "");
            emit($f844812df082fc15$export$9f64346e17f0ec8e, img, Slide);
            emit($f844812df082fc15$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    }
    function loadNext() {
        entries.length && load(entries.shift());
    }
    return {
        mount: mount,
        destroy: $f844812df082fc15$var$apply($f844812df082fc15$var$empty, entries),
        check: check
    };
}
function $f844812df082fc15$var$Pagination(Splide2, Components2, options) {
    var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Slides = Components2.Slides, Elements = Components2.Elements, Controller = Components2.Controller;
    var hasFocus = Controller.hasFocus, getIndex = Controller.getIndex, go = Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $f844812df082fc15$export$db40ab7c0855fa5c,
            $f844812df082fc15$export$7f4701ac5e05e39f,
            $f844812df082fc15$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $f844812df082fc15$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $f844812df082fc15$export$2aa493d7c3275167,
                $f844812df082fc15$export$49801896908b5e33,
                $f844812df082fc15$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($f844812df082fc15$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    function destroy() {
        if (list) {
            $f844812df082fc15$var$remove(placeholder ? $f844812df082fc15$var$slice(list.children) : list);
            $f844812df082fc15$var$removeClass(list, paginationClasses);
            $f844812df082fc15$var$empty(items);
            list = null;
        }
        event.destroy();
    }
    function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? Controller.getEnd() + 1 : $f844812df082fc15$var$ceil(length / perPage);
        list = placeholder || $f844812df082fc15$var$create("ul", classes.pagination, Elements.track.parentElement);
        $f844812df082fc15$var$addClass(list, paginationClasses = $f844812df082fc15$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ROLE, "tablist");
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ARIA_LABEL, i18n.select);
        $f844812df082fc15$var$setAttribute(list, $f844812df082fc15$var$ARIA_ORIENTATION, getDirection() === $f844812df082fc15$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $f844812df082fc15$var$create("li", null, list);
            var button = $f844812df082fc15$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $f844812df082fc15$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $f844812df082fc15$var$apply(onKeydown, i));
            $f844812df082fc15$var$setAttribute(li, $f844812df082fc15$var$ROLE, "presentation");
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ROLE, "tab");
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ARIA_CONTROLS, controls.join(" "));
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$ARIA_LABEL, $f844812df082fc15$var$format(text, i + 1));
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    }
    function onClick(page) {
        go(">" + page, true);
    }
    function onKeydown(page, e) {
        var length = items.length;
        var key = $f844812df082fc15$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($f844812df082fc15$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($f844812df082fc15$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $f844812df082fc15$var$focus(item.button);
            go(">" + nextPage);
            $f844812df082fc15$var$prevent(e, true);
        }
    }
    function getDirection() {
        return options.paginationDirection || options.direction;
    }
    function getAt(index) {
        return items[Controller.toPage(index)];
    }
    function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $f844812df082fc15$var$removeClass(button, $f844812df082fc15$export$72d36ecf3758cb4b);
            $f844812df082fc15$var$removeAttribute(button, $f844812df082fc15$var$ARIA_SELECTED);
            $f844812df082fc15$var$setAttribute(button, $f844812df082fc15$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $f844812df082fc15$var$addClass(_button, $f844812df082fc15$export$72d36ecf3758cb4b);
            $f844812df082fc15$var$setAttribute(_button, $f844812df082fc15$var$ARIA_SELECTED, true);
            $f844812df082fc15$var$setAttribute(_button, $f844812df082fc15$var$TAB_INDEX, "");
        }
        emit($f844812df082fc15$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $f844812df082fc15$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $f844812df082fc15$var$Sync(Splide2, Components2, options) {
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    }
    function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $f844812df082fc15$var$empty(events);
    }
    function remount() {
        destroy();
        mount();
    }
    function sync(splide, target) {
        var event = $f844812df082fc15$export$f188226459c8a3ff(splide);
        event.on($f844812df082fc15$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($f844812df082fc15$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    }
    function navigate() {
        var event = $f844812df082fc15$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($f844812df082fc15$export$5adb665701eda1ce, onClick);
        on($f844812df082fc15$export$6d5af59619d10e6a, onKeydown);
        on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($f844812df082fc15$export$84015c33508f94ec, Splide2.splides);
    }
    function update() {
        $f844812df082fc15$var$setAttribute(Components2.Elements.list, $f844812df082fc15$var$ARIA_ORIENTATION, options.direction === $f844812df082fc15$export$97170d9824b89709 ? "vertical" : "");
    }
    function onClick(Slide) {
        Splide2.go(Slide.index);
    }
    function onKeydown(Slide, e) {
        if ($f844812df082fc15$var$includes($f844812df082fc15$var$TRIGGER_KEYS, $f844812df082fc15$var$normalizeKey(e))) {
            onClick(Slide);
            $f844812df082fc15$var$prevent(e);
        }
    }
    return {
        setup: $f844812df082fc15$var$apply(Components2.Media.set, {
            slideFocus: $f844812df082fc15$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $f844812df082fc15$var$Wheel(Splide2, Components2, options) {
    var _EventInterface12 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $f844812df082fc15$var$SCROLL_LISTENER_OPTIONS);
    }
    function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $f844812df082fc15$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($f844812df082fc15$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $f844812df082fc15$var$prevent(e);
        }
    }
    function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($f844812df082fc15$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    }
    return {
        mount: mount
    };
}
var $f844812df082fc15$var$SR_REMOVAL_DELAY = 90;
function $f844812df082fc15$var$Live(Splide2, Components2, options) {
    var _EventInterface13 = $f844812df082fc15$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $f844812df082fc15$var$create("span", $f844812df082fc15$export$bb78d7c200da8960);
    var interval = $f844812df082fc15$export$46ad21b25b6dccf0($f844812df082fc15$var$SR_REMOVAL_DELAY, $f844812df082fc15$var$apply(toggle, false));
    function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_ATOMIC, true);
            sr.textContent = "\u2026";
            on($f844812df082fc15$export$23663268a31b79e2, $f844812df082fc15$var$apply(disable, true));
            on($f844812df082fc15$export$16a1e4f3d0368265, $f844812df082fc15$var$apply(disable, false));
            on([
                $f844812df082fc15$export$fe5802204b967f0d,
                $f844812df082fc15$export$ff8164bff3202b9
            ], $f844812df082fc15$var$apply(toggle, true));
        }
    }
    function toggle(active) {
        $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_BUSY, active);
        if (active) {
            $f844812df082fc15$var$append(track, sr);
            interval.start();
        } else {
            $f844812df082fc15$var$remove(sr);
            interval.cancel();
        }
    }
    function destroy() {
        $f844812df082fc15$var$removeAttribute(track, [
            $f844812df082fc15$var$ARIA_LIVE,
            $f844812df082fc15$var$ARIA_ATOMIC,
            $f844812df082fc15$var$ARIA_BUSY
        ]);
        $f844812df082fc15$var$remove(sr);
    }
    function disable(disabled) {
        if (enabled) $f844812df082fc15$var$setAttribute(track, $f844812df082fc15$var$ARIA_LIVE, disabled ? "off" : "polite");
    }
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $f844812df082fc15$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $f844812df082fc15$var$Media,
    Direction: $f844812df082fc15$var$Direction,
    Elements: $f844812df082fc15$var$Elements,
    Slides: $f844812df082fc15$var$Slides,
    Layout: $f844812df082fc15$var$Layout,
    Clones: $f844812df082fc15$var$Clones,
    Move: $f844812df082fc15$var$Move,
    Controller: $f844812df082fc15$var$Controller,
    Arrows: $f844812df082fc15$var$Arrows,
    Autoplay: $f844812df082fc15$var$Autoplay,
    Cover: $f844812df082fc15$var$Cover,
    Scroll: $f844812df082fc15$var$Scroll,
    Drag: $f844812df082fc15$var$Drag,
    Keyboard: $f844812df082fc15$var$Keyboard,
    LazyLoad: $f844812df082fc15$var$LazyLoad,
    Pagination: $f844812df082fc15$var$Pagination,
    Sync: $f844812df082fc15$var$Sync,
    Wheel: $f844812df082fc15$var$Wheel,
    Live: $f844812df082fc15$var$Live
});
var $f844812df082fc15$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $f844812df082fc15$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $f844812df082fc15$export$ba41d43e4a419565,
    i18n: $f844812df082fc15$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $f844812df082fc15$var$Fade(Splide2, Components2, options) {
    var Slides = Components2.Slides;
    function mount() {
        $f844812df082fc15$export$f188226459c8a3ff(Splide2).on([
            $f844812df082fc15$export$d300dc1a2634364b,
            $f844812df082fc15$export$7f4701ac5e05e39f
        ], init);
    }
    function init() {
        Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    }
    function start(index, done) {
        Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $f844812df082fc15$var$nextTick(done);
    }
    return {
        mount: mount,
        start: start,
        cancel: $f844812df082fc15$var$noop
    };
}
function $f844812df082fc15$var$Slide(Splide2, Components2, options) {
    var Move = Components2.Move, Controller = Components2.Controller, Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $f844812df082fc15$var$apply($f844812df082fc15$var$style, list, "transition");
    var endCallback;
    function mount() {
        $f844812df082fc15$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    }
    function start(index, done) {
        var destination = Move.toPosition(index, true);
        var position = Move.getPosition();
        var speed = getSpeed(index);
        if ($f844812df082fc15$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            Move.jump(index);
            done();
        }
    }
    function cancel() {
        transition("");
        Scroll.cancel();
    }
    function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($f844812df082fc15$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = Controller.getIndex(true);
            var end = Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    }
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $f844812df082fc15$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $f844812df082fc15$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $f844812df082fc15$export$7254cc27399e90bd($f844812df082fc15$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $f844812df082fc15$var$isString(target) ? $f844812df082fc15$var$query(document, target) : target;
        $f844812df082fc15$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $f844812df082fc15$var$merge({
            label: $f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ARIA_LABEL) || "",
            labelledby: $f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$ARIA_LABELLEDBY) || ""
        }, $f844812df082fc15$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $f844812df082fc15$var$merge(options, JSON.parse($f844812df082fc15$var$getAttribute(root, $f844812df082fc15$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $f844812df082fc15$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($f844812df082fc15$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $f844812df082fc15$var$assert(state.is([
            $f844812df082fc15$var$CREATED,
            $f844812df082fc15$var$DESTROYED
        ]), "Already mounted!");
        state.set($f844812df082fc15$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($f844812df082fc15$export$742b62a5690c060) ? $f844812df082fc15$var$Fade : $f844812df082fc15$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $f844812df082fc15$var$assign({}, $f844812df082fc15$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $f844812df082fc15$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $f844812df082fc15$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($f844812df082fc15$export$d300dc1a2634364b);
        $f844812df082fc15$var$addClass(this.root, $f844812df082fc15$export$7761661e2d5b9388);
        state.set($f844812df082fc15$var$IDLE);
        this.emit($f844812df082fc15$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($f844812df082fc15$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($f844812df082fc15$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($f844812df082fc15$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($f844812df082fc15$var$CREATED)) $f844812df082fc15$export$f188226459c8a3ff(this).on($f844812df082fc15$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $f844812df082fc15$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($f844812df082fc15$export$88c4cf7419e470cd);
            event.destroy();
            completely && $f844812df082fc15$var$empty(this.splides);
            state.set($f844812df082fc15$var$DESTROYED);
        }
        return this;
    };
    $f844812df082fc15$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $f844812df082fc15$export$24494c7438c070bf = $f844812df082fc15$var$_Splide;
$f844812df082fc15$export$24494c7438c070bf.defaults = {};
$f844812df082fc15$export$24494c7438c070bf.STATES = $f844812df082fc15$var$STATES;
var $f844812df082fc15$var$CLASS_RENDERED = "is-rendered";
var $f844812df082fc15$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $f844812df082fc15$var$Style = /*#__PURE__*/ function() {
    function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    }
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $f844812df082fc15$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $f844812df082fc15$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $f844812df082fc15$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $f844812df082fc15$var$merge($f844812df082fc15$export$f484e977a69c6ba6, defaults || {});
        $f844812df082fc15$var$merge($f844812df082fc15$var$merge(this.options, $f844812df082fc15$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $f844812df082fc15$var$assign({}, $f844812df082fc15$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $f844812df082fc15$var$uniqueId("splide");
        this.Style = new $f844812df082fc15$var$Style(this.id, this.options);
        this.Direction = $f844812df082fc15$var$Direction(null, null, this.options);
        $f844812df082fc15$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    }
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $f844812df082fc15$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $f844812df082fc15$var$queryAll(root, "." + $f844812df082fc15$export$2c1ba4a4f1aa4947);
        on($f844812df082fc15$export$d300dc1a2634364b, function() {
            $f844812df082fc15$var$remove($f844812df082fc15$var$child(root, "style"));
        });
        $f844812df082fc15$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $f844812df082fc15$var$push(this.slides, this.contents.map(function(content, index) {
            content = $f844812df082fc15$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $f844812df082fc15$export$72d36ecf3758cb4b : "");
            $f844812df082fc15$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $f844812df082fc15$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $f844812df082fc15$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $f844812df082fc15$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $f844812df082fc15$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $f844812df082fc15$var$unit(padding[prop] || ($f844812df082fc15$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $f844812df082fc15$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $f844812df082fc15$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $f844812df082fc15$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $f844812df082fc15$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $f844812df082fc15$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($f844812df082fc15$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $f844812df082fc15$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $f844812df082fc15$var$merge($f844812df082fc15$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $f844812df082fc15$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $f844812df082fc15$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $f844812df082fc15$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $f844812df082fc15$export$93b21159ad85c843,
            $f844812df082fc15$export$93b21159ad85c843 + "--" + options.type,
            $f844812df082fc15$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $f844812df082fc15$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $f844812df082fc15$export$93b21159ad85c843 + "--nav",
            $f844812df082fc15$export$72d36ecf3758cb4b,
            !this.config.hidden && $f844812df082fc15$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $f844812df082fc15$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $f844812df082fc15$var$camelToKebab(key) + "=\"" + value + "\"" : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $f844812df082fc15$var$forOwn(styles, function(value, key) {
            style += " " + $f844812df082fc15$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$f844812df082fc15$var$push(slides, slides);
        $f844812df082fc15$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $f844812df082fc15$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $f844812df082fc15$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $f844812df082fc15$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += "<div class=\"" + this.options.classes.arrows + "\">";
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + $f844812df082fc15$var$XML_NAME_SPACE + "\" viewBox=\"0 0 " + $f844812df082fc15$var$SIZE + " " + $f844812df082fc15$var$SIZE + "\" width=\"" + $f844812df082fc15$var$SIZE + "\" height=\"" + $f844812df082fc15$var$SIZE + "\"><path d=\"" + (this.options.arrowPath || $f844812df082fc15$var$PATH) + "\" /></svg></button>";
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += "<div class=\"splide__slider\">";
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += "<div class=\"splide__track\">";
        html += "<" + listTag + " class=\"splide__list\">";
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


function $e927ecdfdb54dea1$export$2e2bcd8739ae039() {
    const featureSlides = document.querySelectorAll('.splide--features');
    if (featureSlides.length > 0) featureSlides.forEach((featureSlide)=>{
        new (0, $f844812df082fc15$export$24494c7438c070bf)(featureSlide, {
            perMove: 1,
            perPage: 3,
            gap: '0.875em',
            pagination: false,
            loop: true,
            type: 'loop'
        }).mount();
    });
    const testimonialsSlides = document.querySelectorAll('.splide--testimonials');
    if (testimonialsSlides.length > 0) testimonialsSlides.forEach((testimonialsSlide)=>{
        new (0, $f844812df082fc15$export$24494c7438c070bf)(testimonialsSlide, {
            perMove: 1,
            perPage: 1,
            gap: '0.875em',
            loop: false,
            type: 'slide',
            arrows: true,
            pagination: true
        }).mount();
    });
}


if (document.readyState !== 'loading') $901b434ffda3f0ef$var$runOnStart();
else document.addEventListener('DOMContentLoaded', ()=>{
    $901b434ffda3f0ef$var$runOnStart();
});
function $901b434ffda3f0ef$var$runOnStart() {
    // Run your code here
    (0, $a3951d9daf6e8f2f$export$2e2bcd8739ae039)();
    (0, $4a50c2ddd107be52$export$2e2bcd8739ae039)();
    (0, $138acfe71a391c39$export$2e2bcd8739ae039)();
    (0, $e927ecdfdb54dea1$export$2e2bcd8739ae039)();
}

})();
//# sourceMappingURL=app.js.map
